import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import alert from "components/elements/Alert";
import useOptions from "features/masterData/hooks/useOptions";
import dayjs from "dayjs";

import { Button, Card, Col, Flex, Form, List, message, Modal, Row, Upload } from "antd";
import { Alert } from "components/elements";
import useOrganization from "features/company/hooks/useOrganization";
import usePosition from "features/company/hooks/usePosition";
import { useTranslation } from "react-i18next";
import { generateRandomString } from "utils/helper";
import { ReactComponent as DownloadIcon } from "../../../assets/icon/downloadIcon.svg";
import { ReactComponent as ExcelIcon } from "../../../assets/icon/excelIcon.svg";
import { ReactComponent as UploadIcon } from "../../../assets/icon/uploadIcon.svg";
import * as services from "../services/employeeApi";
import * as slices from "../slices/employeeSlice";
import { setEmployeeList, setIsLoading } from "../slices/employeeSlice";
import styles from "../styles/Employee.module.css";
import useFirebaseNoti from "lib/useFirebaseNoti";
import { onMessage } from "firebase/messaging";
const { Dragger } = Upload;
function toParams(params = {}) {
  const { pagination = {}, sortBy = [] } = params;
  const modifiedParams = {
    pagination: {
      page: pagination.page,
      size: pagination.pageSize,
    },
    sortBy: sortBy
      .filter((s) => s.order !== undefined)
      .map((s) => ({
        direction: s.order === "descend" ? "desc" : "asc",
        property: s.field,
      })),
  };
  return modifiedParams;
}

function useEmployeeList() {
  const { i18n, t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isLoading = useSelector((state) => state.employee.isLoading);
  // const currentEmployee = useSelector((state) => state.company.currentEmployee);
  const currentCompany = useSelector((state) => state.company.currentCompany);
  const employeeList = useSelector((state) => state.employee.employeeList);
  const { employeeTypeOptions = [],
    employmentTypeOptions,
    employeeStatusTypeOptions,
    getEmployeeTypeOptions,
    getEmploymentTypeOptions,
    getEmployeeStstuaTypeOptions, getGender } = useOptions();
  const [pagination, setPagination] = useState({ page: 1, size: 10 });
  const [sorter, setSorter] = useState([]);
  const [fileList, setFileList] = useState([])
  const [openModal, setOpenModal] = useState(false)
  const [disableButton, setDisableButton] = useState(false)
  const [valuesChange, setValuesChange] = useState()

  const location = useLocation();


  const onEdit2 = () => { };

  const {
    departmentOptions,
    positionOptions
  } = useSelector((state) => ({
    departmentOptions: state.employee.departmentOptions,
    positionOptions: state.employee.positionOptions,
  }));
  console.log("pagination", pagination);


  const modifiedOptions = (options) =>
    options?.map((opt) => ({
      ...opt,
      label: i18n.language === "en" ? (opt?.nameEn ? opt?.nameEn : opt.name) : opt.name,
      value: opt.id,
    }));

  const useFetchOptions = (serviceFunction, companyId, groupType, dispatchFunction) => {
    const dispatch = useDispatch();
    useEffect(() => {
      const fetchData = async () => {
        dispatch(slices.setIsLoading(true));
        try {
          const response = await serviceFunction({
            requestId: generateRandomString(),
            companyId,
            groupType,
          });
          dispatch(dispatchFunction(response?.data));
        } catch (error) {
          console.error('Failed to fetch data:', error);
        } finally {
          dispatch(slices.setIsLoading(false));
        }
      };

      if (companyId) {
        fetchData();
      }
    }, [companyId, serviceFunction, groupType, dispatchFunction, dispatch]);
  };


  useFetchOptions(services.getDepartmentOptions, currentCompany, "", slices.setDepartmentOptions);
  useFetchOptions(services.getPositionOptions, currentCompany, "", slices.setPositionOptions);

  const { organizationUnderOptions = [], getDepartment = () => { } } = useOrganization();

  const modifiedDepartmentOptions = useMemo(() => modifiedOptions(departmentOptions), [departmentOptions, i18n.language]);
  const modifiedPositionOption = useMemo(() => modifiedOptions(positionOptions), [positionOptions, i18n.language]);

  const { modifiedPositionOptions = [], getPosition = () => { } } = usePosition(onEdit2);
  const [shiftDropDown, setShiftDropDown] = useState([]);
  const { workInLocationOptions } = useSelector(
    (state) => state.employee
  );
  const { gender } = useSelector(
    (state) => state.options
  );
  const { durationOptions } = useSelector(
    (state) => state.employee
  );

  const onSubmit = useCallback(
    async (values) => {
      const modifiedValues = { ...values, companyId: currentCompany };
      setValuesChange({ ...valuesChange, ...values });
      try {
        let expireDate = null;
        let expireDateEnd = null;
        if (values.expireDateRange) {
          expireDate = values.expireDateRange[0].format("YYYY-MM-DD")
          expireDateEnd = values.expireDateRange[1].format("YYYY-MM-DD")
        }
        let employmentDate = null;
        let employmentDateEnd = null;
        if (values.employmentDateRange) {
          employmentDate = values.employmentDateRange[0].format("YYYY-MM-DD")
          employmentDateEnd = values.employmentDateRange[1].format("YYYY-MM-DD")
        }
        dispatch(setIsLoading(true));
        const response = await services.getEmployeeList({
          ...values,
          requestId: generateRandomString(),
          companyId: currentCompany,
          expireDate,
          expireDateEnd,
          employmentDate,
          employmentDateEnd,
          sortBy: values.sortBy,
          page: 0,
          size: 10,
        });

        dispatch(setEmployeeList(response.data?.content || []));
        setPagination({
          ...pagination,
          page: 0,
          size: 10,
          current: 1,
          total: response.data?.totalItems,
        });
      } catch (error) {
        // alert({ type: "error", resultObject: error });
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [currentCompany, dispatch, pagination, valuesChange]
  );

  const getAttendanceShiftOptions = useCallback(async () => {
    try {
      dispatch(setIsLoading(true));
      const response = await services.getShiftOptions({
        requestId: generateRandomString(),
        companyId: currentCompany,
      });
      const modifiedOptions = response?.data?.map((opt) => ({
        ...opt,
        label: i18n.language === "en" ? opt.nameEn : opt.name,
        value: opt.id,
      }));
      setShiftDropDown(modifiedOptions);
    } catch (error) {
    } finally {
      dispatch(setIsLoading(false));
    }
  }, [currentCompany, i18n.language]);

  const getEmployeeList = useCallback(
    async (params = {}) => {
      try {
        console.log("valuesChange", valuesChange);

        let expireDate = null;
        let expireDateEnd = null;
        if (params.expireDateRange) {
          expireDate = params.expireDateRange[0].format("YYYY-MM-DD")
          expireDateEnd = params.expireDateRange[1].format("YYYY-MM-DD")
        }
        let employmentDate = null;
        let employmentDateEnd = null;
        if (params.employmentDateRange) {
          employmentDate = params.employmentDateRange[0].format("YYYY-MM-DD")
          employmentDateEnd = params.employmentDateRange[1].format("YYYY-MM-DD")
        }
        dispatch(setIsLoading(true));
        const response = await services.getEmployeeList({
          requestId: generateRandomString(),
          companyId: currentCompany,
          genderId: params.genderId,
          listEmployeeTypeId: params.listEmployeeTypeId,
          listBranch: params.listBranch,
          listEmployeeStatus: params.listEmployeeStatus,
          listDepartmentId: params.listDepartmentId || null,
          expireDate,
          expireDateEnd,
          employmentDate,
          employmentDateEnd,
          ...params.pagination,
          sortBy: params.sortBy,
          ...valuesChange
          ,
        });
        setValuesChange({
          genderId: params.genderId,
          listEmployeeTypeId: params.listEmployeeTypeId,
          listBranch: params.listBranch,
          listEmployeeStatus: params.listEmployeeStatus,
          listDepartmentId: params.listDepartmentId || null,
          expireDate: params.expireDate,
          ...valuesChange,
        })

        dispatch(setEmployeeList(response.data?.content || []));
        setPagination({
          ...pagination,
          total: response.data?.totalItems,
        });
      } catch (error) {
        // alert({ type: "error", resultObject: error });
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [currentCompany, dispatch, pagination, valuesChange]
  );
  const getEmployeeListCn = useCallback(
    async (params = {}) => {
      try {
        console.log("valuesChange pagination", valuesChange, params.pagination);

        dispatch(setIsLoading(true));
        const response = await services.getEmployeeList({
          requestId: generateRandomString(),
          companyId: currentCompany,
          genderId: params.genderId,
          listEmployeeTypeId: params.listEmployeeTypeId,
          listBranch: params.listBranch,
          listEmployeeStatus: params.listEmployeeStatus,
          listDepartmentId: params.listDepartmentId || null,
          expireDate: params.expireDate,
          ...params.pagination,
          sortBy: params.sortBy,
          ...valuesChange
          ,
        });
        setValuesChange({
          genderId: params.genderId,
          listEmployeeTypeId: params.listEmployeeTypeId,
          listBranch: params.listBranch,
          listEmployeeStatus: params.listEmployeeStatus,
          expireDate: params.expireDate,
          ...valuesChange,
        })

        dispatch(setEmployeeList(response.data?.content || []));
        setPagination(prev => ({
          ...prev,
          page: response.data?.pageNo + 1,
          current: response.data?.pageNo + 1,
          pageNo: response.data?.pageNo,
          pageSize: response.data?.pageSize,
          total: response.data?.totalItems,
        }));
      } catch (error) {
        // alert({ type: "error", resultObject: error });
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [currentCompany, dispatch, valuesChange, setPagination, pagination]
  );

  console.log('paginationpagination', pagination);


  const getDurationOptions = useCallback(async () => {
    try {
      dispatch(slices.setIsLoading(true));
      const response = await services.getEmployeeDurationOptions({
        groupTypeCode: "DURATION_WORK"
      });
      dispatch(slices.setDurationOptions(response.data));
    } catch (error) {
      alert({
        type: "error",
        resultObject: error,
        message: "Get company type failed!!!",
      });
    } finally {
      dispatch(slices.setIsLoading(false));
    }
  }, [currentCompany]);

  const getWorkInLocationOptions = useCallback(async () => {
    try {
      dispatch(slices.setIsLoading(true));
      const response = await services.getWorkInLocationOptions({
        requestId: generateRandomString(),
        companyId: currentCompany,
      });
      dispatch(slices.setWorkInLocationOptions(response.data));
    } catch (error) {
    } finally {
      dispatch(slices.setIsLoading(false));
    }
  }, [currentCompany]);

  const modifiedWorkInLocationOptions = useMemo(() => {
    const modifiedOptions = workInLocationOptions?.map((opt) => ({
      ...opt,
      label: opt.name,
      value: opt.id,
    }));
    return modifiedOptions;
  }, [workInLocationOptions]);


  const modifiedDurationOptions = useMemo(() => {
    const modifiedOptions = durationOptions?.map((opt) => ({
      ...opt,
      label: i18n.language === "en" ? opt.nameEn : opt.name,
      value: opt.code,
    }));
    return modifiedOptions;
  }, [durationOptions, i18n.language]);

  const modifiedGenderOptions = useMemo(() => {
    const modifiedOptions = gender?.map((opt) => ({
      ...opt,
      label: i18n.language === "en" ? opt.nameEn : opt.name,
      value: opt.id,
    }));
    console.log("modifiedOptions", modifiedOptions,);

    return [{
      label: i18n.language === "en" ? 'unknown' : 'ไม่ระบุเพศ',
      value: "null",
    }, ...modifiedOptions];
  }, [gender, i18n.language]);

  const handleOnChange = useCallback(
    (tablePagination, tableFilters, tableSorter, tableExtra) => {
      console.log("tablePagination", tablePagination);

      const modifiedSorter = Array.isArray(tableSorter)
        ? [...tableSorter]
        : [tableSorter];
      setSorter(modifiedSorter);
      const modifiedParams = toParams({
        pagination: {
          page: tablePagination.current - 1,
          pageSize: tablePagination.pageSize,
        },
        sortBy: modifiedSorter,
      });
      getEmployeeListCn(modifiedParams);
    },
    [getEmployeeListCn, valuesChange]
  );

  const { roles } = useSelector((state) => state.company);
  function getItem(rules, label, key) {
    let list = [...roles]
    if (!list.includes(rules)) {
      return {}
    }
    return {
      // rules: rules,
      label: label,
      key: key,
    };
  }
  const EMPLOYEE_MENU_LIST = [
    getItem("ACCESS_EMPLOYEE|EMPLOYEE_INFO", t('employee.employee_info.header'), 'employee_info'),
    getItem("ACCESS_EMPLOYEE|EMPLOYMENT", t('employee.employment.header'), 'employment'),
    getItem("ACCESS_EMPLOYEE|WORK_IN", t('employee.workin.header'), 'workin'),
    getItem("ACCESS_EMPLOYEE|PERFORMANCE", t('employee.performance.header'), 'performance'),
    getItem("ACCESS_EMPLOYEE|DOCUMENT", t('employee.document.header'), 'document'),
    getItem("ACCESS_EMPLOYEE|SALARY", t('employee.salary.header'), 'salary'),
  ];

  // useMemo(() => {
  //   if (EMPLOYEE_MENU_LIST.filter(o => o.label).length > 0) {
  //     navigate(`/employee/${params.id}/${EMPLOYEE_MENU_LIST.filter(o => o.label)?.[0].key}`);
  //   }
  // }, [EMPLOYEE_MENU_LIST.filter(o => o.label).map(o => o.key)]);
  const onView = useCallback(
    (id) => {
      console.log("onView", EMPLOYEE_MENU_LIST.filter(o => o.label), `${EMPLOYEE_MENU_LIST.filter(o => o.label)?.[0].key}`);

      if (id) navigate(`/employee/${id}/${EMPLOYEE_MENU_LIST.filter(o => o.label)?.[0].key}`);
    },
    [navigate, EMPLOYEE_MENU_LIST]
  );

  const onEdit = useCallback(
    (id) => {
      console.log("onEdit", EMPLOYEE_MENU_LIST.filter(o => o.label));
      if (id) navigate(`/employee/${id}/${EMPLOYEE_MENU_LIST.filter(o => o.label)?.[0].key}`);
    },
    [navigate, EMPLOYEE_MENU_LIST]
  );

  function onClear() {
    console.log("location", location);
    location.state = {}
    setValuesChange({})
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  async function callUpload() {
    Modal.confirm({
      title: t("dialog.confirmation.header"),
      content: (i18n.language === "en"
        ? <span>Are you sure confirm to upload ?</span>
        : <span>คุณแน่ใจที่จะยืนยันการอัปโหลดหรือไม่ ?</span>
      ),
      async onOk() {
        let res = await services.verifyEmployee({ file: fileList?.[0] });

        // console.log("res", res?.data?.size, res);

        if (res?.data instanceof Blob && res.headers["content-type"] === "application/json") {
          let jsonText = await res.data?.text();
          let jsonData = JSON.parse(jsonText);

          if (jsonData?.status?.code === "400") {
            const errorDetail = jsonData?.status?.details?.find(detail => detail.key === "FILE INVALID");
            if (errorDetail) {
              Modal.error({ content: i18n.language === "en" ? "Invalid xlsx file format" : "ไม่สามารถนำเข้าไฟล์ได้ เนื่องจากไม่ใช่แบบฟอร์มข้อมูลพนักงาน", okText: t("confirm") });
              return;
            }
          }

        }

        if (res?.data?.size == '120') {
          getEmployeeList({ pagination: { page: 0, size: 10 } })
          setOpenModal(false)
          setFileList([])
          message.success(t("common.success"))
        }
        else if (res?.data?.size == '265') {
          // alert({ message: "Invalid xlsx file format" });
          Modal.error({ content: "Invalid xlsx file format", okText: t("confirm") })
        }
        else {
          const url = window.URL.createObjectURL(res?.data);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', "import-employee-fail.xlsx");
          document.body.appendChild(link);
          link.click();
          link.remove();
          // exportExcelEmployeeFail(data);
        }
      },
      okText: t("common.confirm").toUpperCase(),
      cancelText: t("common.cancel").toUpperCase(),
    });
  }

  const modalDownload = useCallback(async () => {
    try {
      dispatch(setIsLoading(true));
      await services.exportExcelEmployee().then(res => {
        const url = window.URL.createObjectURL(res?.data);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', "import-employee-template.xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
    } catch (error) {
    } finally {
      dispatch(setIsLoading(false));
    }
  },
    [dispatch],
  )

  function xlsxIcon() {
    return <svg width="30" height="30" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.4843 1.84619H9.84619V3.6825H11.7114V4.93235H9.84619V6.15388H11.6923V7.38465H9.84619V8.61542H11.6923V9.84619H9.84619V11.077H11.6923V12.3077H9.84619V14.1539H15.4843C15.768 14.1539 16 13.9133 16 13.6185V2.38158C16 2.08681 15.768 1.84619 15.4843 1.84619ZM14.7693 12.3077H12.3077V11.077H14.7693V12.3077ZM14.7693 9.84619H12.3077V8.61542H14.7693V9.84619ZM14.7693 7.38465H12.3077V6.15388H14.7693V7.38465ZM14.7693 4.92311H12.3077V3.69235H14.7693V4.92311Z" fill="#1E6E42" />
      <path d="M0 1.77785V14.2228L9.23077 16V0L0 1.77785ZM5.83877 11.1262L4.76492 9.096C4.72431 9.02031 4.68246 8.88123 4.63877 8.67877H4.62215C4.60185 8.77415 4.55385 8.91938 4.47815 9.11385L3.40062 11.1262H1.72738L3.71385 8.00985L1.89662 4.89292H3.60492L4.496 6.76185C4.56554 6.90954 4.62769 7.08492 4.68308 7.28738H4.70031C4.73538 7.16554 4.80062 6.98462 4.896 6.744L5.88677 4.89231H7.45108L5.58215 7.98277L7.50338 11.1255L5.83877 11.1262Z" fill="#1E6E42" />
    </svg>

  }

  const ModalUpload = useCallback(
    () => {
      // console.log("file", fileList)
      function fileSize(item) {
        if (item.size / 1000000 > 1) {
          return (item.size / 1000000) + " mb"
        } else if (item.size / 1000 > 1) {
          return (item.size / 1000) + " kb"
        } else {
          return item.size + " byte"
        }
      }
      return <Modal
        footer={
          <Row style={{ marginTop: "24px", justifyContent: "end", gap: 12 }}>
            <Button onClick={() => {
              setFileList([])
              setOpenModal(false)
            }} style={{ borderRadius: 8, padding: "8px 16px", width: "max-content", height: "max-content" }}>
              {t('action.cancel')}
            </Button>
            <Button type="primary" onClick={() => {
              callUpload()
            }}
              style={{ borderRadius: 8, padding: "8px 16px", width: "max-content", height: "max-content", backgroundColor: !fileList.length ? "" : "var(--button-color)" }}
              disabled={!fileList.length}
            >
              {t('action.submit')}
            </Button>

          </Row>
        }
        title={
          <Form.Item className={styles.content2}
            colon={false}
            label={<span style={{ fontSize: "16px", color: "#475467" }}>{t("common.import_data")}</span>}
          >
          </Form.Item>
        }
        destroyOnClose
        closable={false}
        open={openModal}
        closeIcon={() => { }}
        onCancel={() => {
          setFileList([])
          setOpenModal(false)
        }}
        // okButtonProps={() => {
        //   return false
        // }}
        // cancelButtonProps={() => {
        //   return false
        // }}
        onOk={() => {
          callUpload()
        }}>
        <Dragger
          fileList={fileList}
          type="drag"
          maxCount={1}
          listType="picture"
          showUploadList={true}
          style={{ backgroundColor: "white", borderRadius: "12px" }}
          onDrop={(e) => {
            console.log("onDrop", e);
          }}
          itemRender={(e, file, fileList, action) => {
            console.log("itemRender", e, file, fileList, action);
            return <List dataSource={fileList}
              renderItem={(item) => (
                <List.Item key={1}>
                  <List.Item.Meta
                    avatar={xlsxIcon()}
                    title={item.name}
                    description={fileSize(item)}
                  />
                  <Button style={{
                    border: "transparent"
                  }} icon={"x"} onClick={() => { action.remove() }} >
                    {/* {t('whiteList..download')} */}
                  </Button>
                </List.Item>
              )}
            />
          }}
          beforeUpload={(info) => {
            return false;
          }

          }
          onChange={(info) => {
            console.log("info", info);
            if (info.file?.name && !info.file?.name?.endsWith("xlsx")) {
              Alert({ type: "error", message: "ระบบรองรับไฟล์ xlsx", noti: true })
              setFileList([])
            } else if (info.file?.name) {
              console.log("info?.file", info?.file);
              setFileList([info?.file])
            }
          }}
          onRemove={() => {
            console.log("onRemove");
            setFileList([])
          }}
        >
          <Flex style={{
            height: "20vh",
            rowGap: "14px"
          }} vertical justify="center" align="center">
            <Flex style={{ width: "10%" }} ><UploadIcon /></Flex>
            <Flex>
              <span style={{ color: "#2CADE7", fontWeight: "bold" }}>{t("common.choose_file")}</span>
              &nbsp;
              <span style={{ color: "#475467" }}>{t("common.upload_dnd")}</span>
            </Flex>

          </Flex>
        </Dragger>
        {!fileList?.length > 0 &&
          <Flex style={{
            marginTop: "15px",
            rowGap: "15px"
          }} gap={5} vertical>
            <span style={{ color: "#475467" }}>{t("common.file_support")}</span>

            {/* <div style={{ backgroundColor: "#F5F6F7", padding: "16px", borderRadius: "12px", border: "1px solid #E4E7EC" }}>
              <List dataSource={[]}
              >
                <List.Item key={1}>
                  <List.Item.Meta
                    avatar={xlsxIcon()}
                    title={<span style={{ color: "#42526D" }}>{t("employee.label.template")}</span>}
                    description={<span style={{ color: "#667085" }}>{t("employee.label.template_description")}</span>}
                  />
                  <Button type="default" onClick={() => { modalDownload(); }} disabled={disableButton} style={{ padding: "8px 16px", height: "max-content", borderRadius: "8px" }}>
                    <Flex align="center" justify="center" gap={8}>
                      <DownloadIcon />
                      <span style={{ color: "#667085", fontWeight: "bold" }}>{t('whiteList..download')}</span>
                    </Flex>
                  </Button>
                </List.Item>
              </List>
            </div> */}

            <Card
              style={{ backgroundColor: "#F5F6F7", border: "1px solid #E4E7EC", borderRadius: "12px" }}
              styles={{ body: { padding: "16px" } }}
            >
              <Row style={{ width: "100%" }}>
                <Col span={16}>
                  <Flex gap={16} align="center">
                    <ExcelIcon />
                    <Flex vertical>
                      <span style={{ fontWeight: "bold", color: "#42526D" }}>{t("employee.label.blank_form")}</span>
                      <span style={{ color: "#42526D" }}>{t("employee.label.template_description")}</span>
                    </Flex>
                  </Flex>
                </Col>
                <Col span={8} style={{ justifyItems: "self-end" }}>
                  <Button type="default"
                    style={{
                      height: "40px",
                      borderRadius: "8px",
                      display: "flex",
                      alignItems: "center"
                    }}
                    loading={isLoading}
                    disabled={isLoading}
                    onClick={() => { modalDownload(); }}
                    icon={
                      !isLoading ? (
                        <DownloadIcon style={{ fontSize: 16 }} />
                      ) : (
                        <span style={{ width: 16, height: 16 }} />
                      )
                    }
                  >
                    <span style={{ color: "#59687F", fontWeight: "bold", whiteSpace: "nowrap" }}>{t("common.download")}</span>
                  </Button>
                </Col>
              </Row>
            </Card>

            {/* <Card
              style={{ backgroundColor: "#F5F6F7", border: "1px solid #E4E7EC", borderRadius: "12px" }}
              styles={{ body: { padding: "16px" } }}
            >
              <Row style={{ width: "100%" }}>
                <Col span={16}>
                  <Flex gap={16} align="center">
                    <ExcelIcon />
                    <Flex vertical>
                      <span style={{ fontWeight: "bold", color: "#42526D" }}>{t("employee.label.template")}</span>
                      <span style={{ color: "#42526D" }}>{t("common.excel_file")}</span>
                    </Flex>
                  </Flex>
                </Col>
                <Col span={8} style={{ alignContent: "center", textAlignLast: "right" }}>
                  <Button type="default" style={{ height: "40px", borderRadius: "8px" }}
                  // onClick={() => { modalDownload(); }}
                  >
                    <Flex gap={8}>
                      <DownloadICon />
                      <span style={{ color: "#59687F", fontWeight: "bold" }}>{t("common.download")}</span>
                    </Flex>
                  </Button>
                </Col>
              </Row>
            </Card> */}
          </Flex>
        }
      </Modal>
    },
    [callUpload, openModal, t],
  )

  useEffect(() => {
    if (currentCompany != null) {
      getEmployeeTypeOptions({
        companyId: currentCompany,
        groupType: "EMPLOYEE_TYPE",
      });
      getEmploymentTypeOptions({ companyId: currentCompany });
      getEmployeeStstuaTypeOptions();
    }
  }, [dispatch, currentCompany, getEmployeeTypeOptions, getEmploymentTypeOptions, getEmployeeStstuaTypeOptions]);

  const exportExcelEmployeeFail = useCallback(async (values) => {
    try {
      setDisableButton(true);
      await services.exportExcelEmployeeFail({ ...values }).then(res => {
        const url = window.URL.createObjectURL(res?.data);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', "import-employee-fail.xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
    } catch (error) {
    } finally {
      setDisableButton(false);
    }
  },
    [],
  )
  // const [fcmToken, setFcmToken] = useState(null)

  // const fetchFCMToken = useCallback(async () => {
  //   try {
  //     const token = await requestFCMToken()
  //     setFcmToken(token)
  //     console.log("fcm token ", token);
  //   } catch (error) {
  //     console.log("fcm error ", error);
  //   }
  // })
  const filterValueGender = useCallback(
    () => {
      if (location?.state?.item?.series == 'genderId') {
        return { [location?.state?.item?.series]: modifiedGenderOptions?.find(o => o.label == location?.state?.item?.value)?.value, expireDateRange: [dayjs().startOf('month'), dayjs()] }
      }
      if (location?.state?.item?.series == 'listEmployeeTypeId') {
        return { [location?.state?.item?.series]: location?.state?.item?.value, expireDateRange: [dayjs().startOf('month'), dayjs()] }
      }
      if (location?.state?.item?.series == 'listBranch') {
        return { [location?.state?.item?.series]: location?.state?.item?.value, expireDateRange: [dayjs().startOf('month'), dayjs()] }
      }
      if (location?.state?.item?.series == 'listEmployeeStatus') {
        let size = location?.state?.item?.value
        const startDate = location?.state?.item?.startDate
          ? dayjs(location?.state?.item?.startDate)
          : dayjs().startOf('month')

        const endDate = location?.state?.item?.endDate
          ? dayjs(location?.state?.item?.endDate)
          : dayjs()
        let employmentDateRange = null
        // if (size?.length > 1) {
        //   employmentDateRange = [dayjs(location?.state?.item?.startDate) ?? dayjs().startOf('month'), dayjs()]
        // }
        if (size?.length > 1) {
          employmentDateRange = [startDate, endDate]
        }
        console.log("locationlocation", location, size?.length, employmentDateRange);

        return { [location?.state?.item?.series]: location?.state?.item?.value, employmentDateRange, expireDateRange: [startDate, endDate] }
      }
      if (location?.state?.item?.series == 'listDepartmentId') {
        return { [location?.state?.item?.series]: location?.state?.item?.value || null, expireDateRange: [dayjs().startOf('month'), dayjs()] }
      }
      return { genderId: null, listEmployeeTypeId: null, listEmployeeStatus: null, listBranch: null, listDepartmentId: null }
    },
    [location?.state?.item?.series, location?.state?.item?.startDate, location?.state?.item?.value, modifiedGenderOptions],
  )


  useMemo(() => {
    if (currentCompany != null) {
      getDepartment();
      getPosition({ page: false });
      getWorkInLocationOptions();
      getAttendanceShiftOptions();
      getEmployeeTypeOptions();
      getDurationOptions();
      getEmployeeList({ ...filterValueGender(), pagination: { page: 0, size: 10 } });
      getEmploymentTypeOptions();
      getGender()
    }
  }, [currentCompany]);



  const onDelete = useCallback((employeeId) => { }, []);

  return {
    isLoading,
    pagination,
    employeeList,
    employeeTypeOptions,
    organizationUnderOptions: modifiedDepartmentOptions,
    shiftDropDown: shiftDropDown,
    modifiedPositionOptions,
    workInLocationOptions: modifiedWorkInLocationOptions,
    durationOptions: modifiedDurationOptions,
    employmentTypeOptions,
    getGender: modifiedGenderOptions,
    employeeStatusTypeOptions,
    positionOption: modifiedPositionOption,
    disableButton,
    onView,
    onEdit,
    onSubmit,
    onDelete,
    getEmployeeList,
    setValuesChange,
    onChange: handleOnChange,
    setOpenModal,
    ModalUpload,
    onClear,
    modalDownload,
  };
}

export default useEmployeeList;
